import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { applyAuth } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;
    if (!sessionId) { navigate("/entrar"); return; }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", {}, { headers: { "X-Session-ID": sessionId } });
        applyAuth(data);
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/painel", { replace: true });
      } catch {
        navigate("/entrar");
      }
    })();
  }, [navigate, applyAuth]);

  return (
    <div className="min-h-screen flex flex-col items-center justify-center" data-testid="auth-callback">
      <Loader2 className="w-7 h-7 animate-spin text-blaze" />
      <p className="mt-4 text-sm text-muted-foreground">Entrando com Google...</p>
    </div>
  );
}
